/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IGetAgenciesRequest, TGetAgenciesModel, IMappers, TGetAgenciesResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetAgenciesV2Response } from '../../entities/get_agents/GetAgenciesV2Response';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetAgenciesModel(parameters: IGetAgenciesRequest): TGetAgenciesModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'agent-catalog-search',
    pathApi: '/v2/get-agencies/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetAgenciesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetAgenciesRequest;
}

export async function fetchGetAgencies<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetAgenciesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetAgenciesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetAgenciesModel(parameters),
    config,
  )) as FetchResponse<TGetAgenciesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetAgenciesV2Response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetAgenciesResponse>;
}
